import { Offcanvas, Modal } from 'bootstrap'

/**
 * Bootstrap v5 helpers
 */
class Bootstrap5 {
  /**
  * @constructor
  **/
  constructor() {
  }
  // # Hide all modals, offcanvases, etc.
  hideFlyovers() {
    this.hideModals()
    this.hideOffcanvases()
  }
  // # Hide all modals #
  hideModals() {
    const list = [...document.querySelectorAll(".modal")]
    list.forEach(this.hdieModal.bind(this))
  }
  //  # Hide offcanvas element
  hdieModal(el) {
    const modal = Modal.getInstance(el)
    if (modal) {
      modal.hide()
    }
  }
  // # Hide all offcanvases #
  hideOffcanvases() {
    const list = [...document.querySelectorAll(".offcanvas")]
    list.forEach(this.hdieOffcanvas.bind(this))
  }
  //  # Hide offcanvas element
  hdieOffcanvas(el) {
    const offcanvas = Offcanvas.getInstance(el)
    if (offcanvas) {
      offcanvas.hide()
    }
  }

}

const bootstrap5 = new Bootstrap5();
export default bootstrap5;